import React from 'react';
import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfLogoFarm.module.scss';
import { Image } from '@/components';
let cx = classNames.bind(styles);

export default function AcfLogoFarm(props) {
	const { logoFarm, attributes } = props;
	const className = attributes.className?.split(' ') || [];
	const styles = {
		'--verticalGap': `${logoFarm.verticalGap}rem`,
		'--horizontalGap': `${logoFarm.horizontalGap}rem`,
    '--columnCount': logoFarm.gridSettings?.columnCount,
	};
	return (
		<>
			{logoFarm.logos?.length > 1 && (
				<div className={cx(['ns_logo-farm-container', 'logo-farm-container', attributes.alignLogoContainer && `align-${attributes.alignLogoContainer}`])}>
					<div id={attributes.anchor} className={cx(['ns_logo-farm', 'logo-farm', ...className, logoFarm.display && `display-${logoFarm.display[0]}`, logoFarm.collapseOnMobile && 'collapse', logoFarm.gridSettings?.alignLogos && `justify-logos-${logoFarm.gridSettings?.alignLogos}`])} style={styles}>
						{logoFarm.logos.map((logoAttr, index) => {
							if (logoAttr.logo) {
								const aspectRatio = logoAttr.logo.node.mediaDetails.height / logoAttr.logo.node.mediaDetails.width;
								return (
									<React.Fragment key={index}>
										{logoAttr.logo && (
											<div className={cx(['logo-container'])}>
												<Image image={logoAttr.logo} width={logoAttr.width} height={aspectRatio * logoAttr.width} />
											</div>
										)}
									</React.Fragment>
								);
							}
						})}
					</div>
				</div>
			)}
		</>
	);
}

AcfLogoFarm.fragments = {
	key: `AcfLogoFarmFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfLogoFarmFragment on AcfLogofarm {
			attributes {
				anchor
				className
				alignLogoContainer: align
			}
			logoFarm {
        collapseOnMobile
				display
        gridSettings {
          alignLogos
          columnCount
        }
				horizontalGap
				logos {
          logo {
            ...ImageFragment
					}
					width
				}
        verticalGap
			}
		}
	`,
};

AcfLogoFarm.config = {
	name: 'AcfLogofarm',
};
AcfLogoFarm.displayName = 'AcfLogofarm';
